SupportOrdersIteratorNonPaginatedCollection = require('./orders_iterator_nonpaginated')
SupportOrdersIteratorPaginatedCollection = require('./orders_iterator_paginated')
SupportOrdersFilterConditionsModel = require('../models/orders_filter_conditions')

class SupportOrdersFilterCollection
  constructor: (options) ->
    @ordersModel = Groupon.Support.OrdersCollection
    @setSortAttribute(options.sort_attribute)
    @setSortOrder(options.sort_order)
    @sortedOrders = []
    @conditions = new SupportOrdersFilterConditionsModel
    if window.ordersPaginationEnabled
      @iterator = new SupportOrdersIteratorPaginatedCollection(this)
    else
      @iterator = new SupportOrdersIteratorNonPaginatedCollection(this, @ordersModel)
    @pagination = null

  setSortAttribute: (val) ->
    switch val
      when 'purchased_at'
        @sort_attribute = 'purchased_at'
      when 'merchant_name'
        @sort_attribute = 'merchant_name'
      else
        @sort_attribute = 'purchased_at'

  getSortAttribute: () ->
    @sort_attribute

  setSortOrder: (val) ->
    switch val
      when 'descending'
        @sort_order = 'descending'
      when 'ascending'
        @sort_order = 'ascending'
      else
        @sort_order = 'descending'

  getSortOrder: () ->
    @sort_order

  getOrders: (options, sucessCallback, errorCallback) ->
    _sucessCb = (response) =>
      if response?.pagination
        @pagination = response.pagination
      if response?.orders?.length > 0
        response.orders = @sortOrders(response.orders)
      sucessCallback(response)

    hash = {
      sort_order: @sort_order
      sort_attribute : @sort_attribute
    }
    options = _.extend(options, hash)
    @ordersModel.fetchOrders(options, _sucessCb, errorCallback)

  sortOrders: (orders) ->
    if @ordersModel.getNumberOfOrdersFetched() > @sortedOrders.length
      if @sort_attribute is 'merchant_name'
        if @sort_order is 'descending'
          orders.sort((a,b) => @conditions.sortMerchantNameDescendingFn(a,b))
        else
          orders.sort((a,b) => @conditions.sortMerchantNameAscendingFn(a,b))
      else if @sort_attribute is 'purchased_at'
        if @sort_order is 'descending'
          orders.sort((a,b) => @conditions.sortPurchasedDateDescendingFn(a,b))
        else
          orders.sort((a,b) => @conditions.sortPurchasedDateAscendingFn(a,b))

      orders = _.filter(orders, (order) =>
        orderFound = @findOrderById(order.id)
        if orderFound
          return false
        else
          @sortedOrders.push(order)
          return true
      )
    orders

  findOrderById: (orderId) ->
    if orderId
      orderId = orderId.toString()
      _.find(@sortedOrders, (order) ->
        return order.id?.toString() is orderId
      )
    else
      null

  getFirstOrder: () ->
    if @sortedOrders.length > 0
      @sortedOrders[0]
    else
      null

  isOrdersInfoValid: () ->
    return @iterator.isOrdersInfoValid()

module.exports = SupportOrdersFilterCollection
